export default __webpack_public_path__ + "static/media/Monk's Helm of the Eighteen Pits.9f65387a.jpg";